import {Block} from "../../../components/Landing/Block"
import {Separator} from "../../../components/Landing/Separator"
import styles from "./index.module.scss"
import bellIcon from "../../../assets/landing_bell_icon.png"
import fireIcon from "../../../assets/landing_fire_icon.png"

export const Roadmap = () => {
  const placeHolder = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. " +
    "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, " +
    "when an unknown printer took a galley of type and scrambled it to make a type specimen book. " +
    "It has survived not only five centuries, but also the le"

  return (
    <div className={styles.Container}>
      <div className={styles.Title}>
        We aim to seamlessly on-board developers into Web3
      </div>

      <Separator desc={"2022"}/>
      <div className={styles.StageTitle}>
        Stage 1 - Seamless On-board
      </div>
      <div className={styles.StageSubtitle}>
        Encourage open source collaboration through Web3 reward-driven ecosystem
      </div>

      <Block title={"Journey begins - Q2 2022"} desc={placeHolder} imgSrc={bellIcon}/>
      <Block title={"Git repository layer - Q3 2022"} desc={placeHolder} imgSrc={fireIcon}/>
      <Block title={"Close Alpha - Q4 2022"} desc={placeHolder} imgSrc={bellIcon}/>
      <Block title={"Incentive Layer - Q4 2022"} desc={placeHolder} imgSrc={bellIcon}/>

    </div>
  )
}




